var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('back-button',{attrs:{"color":"grey"},on:{"click":function($event){return _vm.$emit('back')}}}),_vm._v(" "+_vm._s(_vm.title)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }